import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { getClockFormat, setClockFormat } from "reduxSlices/currentSettingsSlice"
import { Select } from "shared/selects"
import * as API from "services/api"
import ItemRow from "shared/ItemRow"
import { errorToast } from "shared/toast"
import { STYLE, CLOCK_FORMAT_TWELVE_HOUR_SETTING, CLOCK_FORMAT_TWENTY_FOUR_HOUR_SETTING } from "utils/generalSettingsHelpers"

const CLOCK_FORMAT_OPTIONS = [
  { label: "12-Hour (AM/PM)", value: CLOCK_FORMAT_TWELVE_HOUR_SETTING },
  { label: "24-Hour", value: CLOCK_FORMAT_TWENTY_FOUR_HOUR_SETTING },
]

const ClockFormat = () => {
  const dispatch = useDispatch()
  const organizationClockFormat = useSelector(getClockFormat)

  const updateOrganizationClockFormat = async (newClockFormat) => {
    const response = await API.updateOrganizationClockFormat({ clockFormat: newClockFormat })

    if (response.ok) {
      dispatch(setClockFormat(newClockFormat))
    } else {
      errorToast("Something went wrong. Unable to update clock format.")
    }
  }

  return (
    <ItemRow
      className="dark content-bar screenreader-whitespace"
      itemRowHeaderContent={(
        <>
          <span className="content-bar-title">Clock Format</span>
          <Select
            style={STYLE}
            options={CLOCK_FORMAT_OPTIONS}
            value={organizationClockFormat}
            onChange={updateOrganizationClockFormat}
            label="select task reminder frequency"
          />
        </>
      )}
    />
  )
}

export default ClockFormat
